/* OmyBoat — Galerie produit : lightbox plein écran (PhotoSwipe v5)
   Clic sur la photo principale → plein écran → swipe (mobile) + flèches/clavier (desktop) + pincer pour zoomer. */
import PhotoSwipeLightbox from 'https://cdn.jsdelivr.net/npm/photoswipe@5.4.4/dist/photoswipe-lightbox.esm.min.js';

(function () {
  var gallery = document.querySelector('#pswp-gallery');
  if (!gallery || !gallery.querySelector('a')) return;

  var isEN = (document.documentElement.lang || '').toLowerCase().indexOf('en') === 0;
  var L = isEN
    ? { close: 'Close', zoom: 'Zoom', prev: 'Previous', next: 'Next' }
    : { close: 'Fermer', zoom: 'Zoom', prev: 'Précédent', next: 'Suivant' };

  var lightbox = new PhotoSwipeLightbox({
    gallery: '#pswp-gallery',
    children: 'a',
    pswpModule: function () {
      return import('https://cdn.jsdelivr.net/npm/photoswipe@5.4.4/dist/photoswipe.esm.min.js');
    },
    bgOpacity: 0.92,
    closeTitle: L.close,
    zoomTitle: L.zoom,
    arrowPrevTitle: L.prev,
    arrowNextTitle: L.next
  });
  lightbox.init();

  // Ouvrir le plein écran au clic sur la photo principale, à l'index de la miniature active
  var main = document.getElementById('galleryMain');
  if (main) {
    main.style.cursor = 'zoom-in';
    main.addEventListener('click', function () {
      var thumbs = Array.prototype.slice.call(document.querySelectorAll('.gallery-thumbs img'));
      var idx = thumbs.findIndex(function (t) { return t.classList.contains('active'); });
      if (idx < 0) idx = 0;
      lightbox.loadAndOpen(idx);
    });
  }
})();
